import React from 'react';
import { Box, SxProps, Theme, Typography } from '@mui/material';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { truncateText } from '../../utils/AppUtils';
import { MAX_CHARACTERS_BACKGROUND } from '../../selectors/selectors';

interface BackgroundColorCardProps {
    backgroundColor?: string;
    text: string;
    sx?: SxProps<Theme>;
}

const BackgroundColorCard: React.FC<BackgroundColorCardProps> = ({ backgroundColor = '#333333', text, sx }) => {
    return (
        <Box
            sx={{
                width: '100%',
                flexShrink: 0,
                background: backgroundColor,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '300px',
                position: 'relative',
                my: 1.5,
                ...sx,
            }}>
            <Typography
                sx={{
                    textAlign: 'center',
                    fontFamily: FONT_ENUM.MAIN_BOLD,
                    fontSize: '24px',
                    color: 'white',
                }}>
                {truncateText(text, MAX_CHARACTERS_BACKGROUND)}
            </Typography>
        </Box>
    );
};

export { BackgroundColorCard };
